import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Card from '../../core/components/Card'
import i18n from '../i18n'
import style from './OpenTicketCompanyCard.less'

class OpenTicketCompanyCard extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, cmd, ...others} = this.props

        const header = (title) => (
            <h3>{title}</h3>
        )

        return ((cmd && cmd.company) != null) && (
            <div className={style.default}>
                <Card
                    header={header(cmd.company.label)}
                    {...others}>
                    <p>{cmd.locationRef && cmd.locationRef.agencyUid && cmd.locationRef.agencyUid.label}</p>
                </Card>
            </div>
        )
    }
}

OpenTicketCompanyCard = connect((state) => ({
    cmd: state.ticket.openTicketCmd
}))(OpenTicketCompanyCard)

export default OpenTicketCompanyCard


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketCompanyCard.js